<template>
    <ul class="w-full text-sm p-1" aria-label="Navegación secundaria">
      <base-aside-nav-item :key="item.name" :item="item" v-for="item in items" v-bind="$attrs" />
    </ul>
</template>

<script>

export default {
  name: 'aside-nav',
  props: {
    items: {
      type: [Object, Array],
      required: true
    }
  },
  data: function () {
    return {

    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    }
  }
}
</script>

<style lang="scss" scoped></style>
